<template>
  <div>
    <organism-discovery
      :fields="fields"
      :items="items"
      :policyList="policyList"
      :tagsList="tagsList"
      :SNMPList="SNMPList"
      :WMIList="WMIList"
      @searchBySubnet="searchBySubnet"
      @addEquipmentDiscovery="addEquipmentDiscovery"
      @addCredentialsBySnmp="addCredentialsBySnmp"
      @addCredentialsByWmi="addCredentialsByWmi"
      @deleteCredentialsBySnmp="deleteCredentialsBySnmp"
      @deleteCredentialsByWmi="deleteCredentialsByWmi"
    >
    </organism-discovery>
  </div>
</template>

<script>
import OrganismDiscovery from "@/components/organisms/OrganismDiscovery.vue"
import {
  getDiscoveryBySubnet,
  getPolicyName,
  getTags,
  addEquipment,
  getCredentialsSnmp,
  getCredentialsWmi,
  addCredentialsSnmp,
  addCredentialsWmi,
  deleteCredentialsSnmp,
  deleteCredentialsWmi,
} from "@/api/api-module"
import mixins from "@/mixins"
export default {
  name: "Discovery",
  components: { OrganismDiscovery },
  mixins: [mixins],
  data() {
    return {
      fields: [
        {
          field: "hostname",
          label: "HOST NAME",
          sortable: true,
        },
        {
          field: "ipAddress",
          label: "IP ADDRESS",
          sortable: true,
        },
        {
          field: "cpu",
          label: "CPU CORE",
          sortable: false,
          thClass: "text-center",
        },
        {
          field: "memory",
          label: "MEMORY (GB)",
          sortable: false,
          thClass: "text-center",
        },
        {
          field: "storage",
          label: "STORAGE (GB)",
          sortable: false,
          thClass: "text-center",
        },
        {
          field: "description",
          label: "DESCRIPTION",
          sortable: false,
        },
      ],
      items: [],
      policyList: [],
      tagsList: [],
      SNMPList: [],
      WMIList: [],
    }
  },
  mounted() {
    this.showLoading(true)
    this.getCredentialsSnmpList()
    this.getCredentialsWmiList()
    this.getPolicyNameList()
    this.getTagsList()
  },
  methods: {
    // discovery equipment
    searchBySubnet(subnet) {
      this.getDiscoveryBySubnetList(subnet)
    },
    async getDiscoveryBySubnetList(subnet) {
      this.items = []
      this.showLoading(true)
      await getDiscoveryBySubnet(subnet)
        .then((response) => {
          response.forEach((equipment) => {
            this.items.push({
              hostname: equipment.hostname,
              ipAddress: equipment.ipAddress,
              description: equipment.description,
              cpu: equipment.totalProcessorCore,
              memory: parseFloat(equipment.totalMemory).toFixed(2),
              storage: parseFloat(equipment.totalStorage).toFixed(2),
              osType: equipment.osType,
              credentialId: equipment.credentialId,
            })
          })
          if (this.items.length === 0) {
            this.toastError("Equipment not found")
          }
        })
        .catch((error) => {
          this.toastError(error.Message)
        })
        .finally(() => this.showLoading(false))
    },

    // get policy name
    async getPolicyNameList() {
      this.showLoading(true)
      await getPolicyName()
        .then((response) => {
          response.forEach((policy) => {
            this.policyList.push({
              id: policy.policyId,
              name: policy.policyName,
            })
          })
        })
        .finally(() => this.showLoading(false))
    },

    // get tags list
    async getTagsList() {
      this.showLoading(true)
      await getTags()
        .then((response) => {
          this.tagsList = response
        })
        .finally(() => this.showLoading(false))
    },

    // add equipment
    async addEquipmentDiscovery(request) {
      this.showLoading(true)

      await addEquipment(request)
        .then((response) => {
          if (response.status === "ok") {
            this.toastSuccess("Equipment added successfully")

            this.$router.push({ name: "serverManagementServerManagement" })
          } else {
            this.toastError("Equipment added failed")
          }
        })
        .finally(() => this.showLoading(false))
    },

    // get credentails
    async getCredentialsSnmpList() {
      this.showLoading(true)
      await getCredentialsSnmp()
        .then((response) => {
          this.SNMPList = response
        })
        .finally(() => this.showLoading(false))
    },

    async getCredentialsWmiList() {
      await getCredentialsWmi()
        .then((response) => {
          this.WMIList = response
        })
        .finally(() => this.showLoading(false))
    },

    // add credentials
    async addCredentialsBySnmp(request) {
      this.showLoading(true)
      const response = await addCredentialsSnmp({
        credentialName: request,
        snmpCommunity: request,
      })
      this.getCredentialsSnmpList()
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("SNMP Community added successfully")
      } else {
        this.toastError("SNMP Community added failed")
      }
    },
    async addCredentialsByWmi(request) {
      this.showLoading(true)
      const response = await addCredentialsWmi({
        credentialName: request.username,
        username: request.username,
        password: request.password,
        ipAddresses: request.ipAddresses,
      })
      this.getCredentialsWmiList()
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("WMI Credential added successfully")
      } else {
        this.toastError("WMI Credential added failed")
      }
    },

    // delete credentials
    async deleteCredentialsBySnmp(id) {
      this.showLoading(true)
      const response = await deleteCredentialsSnmp(id)
      this.getCredentialsSnmpList()
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("SNMP Community deleted successfully")
      } else {
        this.toastError("SNMP Community deleted failed")
      }
    },
    async deleteCredentialsByWmi(id) {
      this.showLoading(true)
      const response = await deleteCredentialsWmi(id)
      this.getCredentialsWmiList()
      this.showLoading(false)
      if (response.status === "ok") {
        this.toastSuccess("WMI Credential deleted successfully")
      } else {
        this.toastError("WMI Credential deleted failed")
      }
    },
  },
}
</script>

<style></style>
